module.exports = __webpack_public_path__ + "4e9f0b30d174e27c284aa241599aec15.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/suppliers/6.png
// module id = 542
// module chunks = 21 54 55 56 77 79 80 88